import React, { Component } from "react";
import { PaymentFailed, LandingBgFail } from "../assets/images";
import styled from "styled-components";
import BookSuccessFooter from "../components/SuccessfulBooking/SuccessBookingFooter";
import DownloadApp from "../components/SuccessfulBooking/DownloadApp";
import Button from "../components/Buttons";
import { Colors } from "../ColorConstants";

const BookingFailed = () => {
  return (
    <BookFailedContainer>
      <BookFailedBanner />
      <BookFailedImageContainer>
        <BookFailedImage src={PaymentFailed} />
      </BookFailedImageContainer>
      <BookFailedActionContainers>
        <FailMessage>Oops! Booking Failed</FailMessage>
        <FailText>
          We apologize, but we encountered an issue while processing your
          payment. Please review your payment details and attempt the
          transaction once more
        </FailText>
        <FailAction>
          <Button label="Try Again" width="15rem" variant="filled" />
        </FailAction>
      </BookFailedActionContainers>
      <SecondSubView>
        <DownloadApp />
      </SecondSubView>
      <BookSuccessFooter />
    </BookFailedContainer>
  );
};

const FailMessage = styled.div`
  color: ${Colors.darkRed};
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  @media only screen and (max-width: 768px) {
    font-size: 2rem;
  }
`;
const FailAction = styled.div``;
const FailText = styled.div`
  width: 50%;
  color: #4e4e4e;
  font-size: 1rem;
  font-weight: 600;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;
const BookFailedContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BookFailedActionContainers = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 1rem;
  padding: 1rem 0;
`;

const BookFailedImage = styled.img``;

const SecondSubView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const BookFailedImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const BookFailedBanner = styled.div`
  height: 24rem;
  background-image: url(${LandingBgFail});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  @media only screen and (max-width: 768px) {
    background-image: none;
    height: 2rem;
  }
`;

export default BookingFailed;
